/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const GET_APPLICATION = gql`
  query GetApplication($applicationNo: String!) {
    getApplication(applicationNo: $applicationNo) {
      appointment
      displayStatus
      createdAt
      updatedAt
      appliedOn
      applicant
      appealInfo {
        applicationNo
        comment
        documents {
          name
          type
          src
          fileType
          expiry
        }
        createdAt
        updatedAt
      }

      marriageInfo {
        nameOfOfficer
        groomName
        marriageCertificateNo
        brideName
        placeOfMarriage
        dateOfMarriage
        addressOfCouple {
          addressLine1
          addressLine2
          city
          country
          parish
        }
      }
      applicantInfo {
        vuid
        userId
        email
        refusionDetail {
          country
          reason
        }
        firstName
        middleName
        lastName
        criminalActivity
        criminalActivityReason
        employed
        noOfYearsWithCompany
        intendedAddress {
          addressLine1
          addressLine2
        }
        financiallyCapable
        maidenName
        middleName
        previouslyMarried
        spouseWorkedInJamaica
        typeOfIdentification
        otherNationality
        countryOfBirth
        passportIssuanceDate
        passportNumber
        passportExpiry
        refusedJamaicanVisa
        refusedJamaicanVisaReason
        refusedVisaOrDenied
        refusedVisaOrDeniedReason
        salary
        spouseNationality
        trn
        addressOfEmployer {
          addressLine1
          city
          parish
          country
        }
        NIS
        divorceOrWidowed
        email
        fullName
        emailVerified
        phoneVerified
        image
        accountStatus
        bannerImg
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
          parish
        }
        occupation
        bio
        primaryContactNo
        nationality

        createdAt
        alias
        childrenOrDependent
        gender
        maritalStatus
        passportExpiry
        passportNumber
        passportType
        placeOfBirth
        qualification {
          institute
          from
          to
          degree
          description
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            state
            parish
            zipcode
            country
          }
          dateReceived
          degreeIfOther
        }
        skills
        trn
        dateOfBirth
        declaration {
          selected
          value
        }
        lastEmployer {
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          country
          dateOfRegistration
          declaration {
            selected
            value
          }
          description
          email
          fax
          incorporationDate
          isSubsidiary
          logo
          name
          natureOfBusiness
          operatingAddress {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          orgId
          primaryContactNo
          registrationNo
          socialLinks
          status
          tradingName
          trn
          type
          website
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
        }
        permissionPeriod {
          from
          to
        }
        spouseName
        spouseNationality
        spouseLastEmployer {
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          country
          dateOfRegistration
          declaration {
            selected
            value
          }
          description
          email
          fax
          incorporationDate
          isSubsidiary
          name
          natureOfBusiness
          operatingAddress {
            addressLine1
            addressLine2
            addressLine3
            city
            country
            parish
            state
            zipcode
          }
          primaryContactNo
          registrationNo
          status
          tradingName
          trn
          type
          website
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
        }
        countryConvicted
        criminalOffence
        dateOfConviction
        natureOfOffence
        workedInJamaica
        workExperience {
          from
          to
          jobDuty
          nameOfOrganization
          refLetter
        }
        dependentInfo {
          dependentType
          name
          passportNumber
          relationship
          age
          documents {
            expiry
            fileType
            name
            src
            type
          }
          gender
          nationality
        }
        isLastNameExist
        destinationCarribbeanState
        natureOfBusiness
        natureOfProfessionalActivity
        purposeOfRelocation
        isFirstNameChange
        isDependentExist
        isMailingAddressSame
        isMiddleNameChange
        isNameChange
        isNationalityChange
        isOccupationChange
        isPassportExpired
        dateOfEntry
        isLastNameChange
        name
        nameChangeDocType
        otherIncomeSource
        notfinanciallyCapableReason
        portOfEntry
        employmentStatus
        highestQualification
        employmentAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
        nameOfEmployer
      }
      applicationNo
      appliedBy
      comment
      documents {
        name
        type
        src
        fileType
        expiry
      }
      jamaicanInfo {
        email
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
          parish
        }
        firstName
        middleName
        lastName
        nationality
        citizenshipProof
        birthCertificateNo
        NaturalizationCertificateNo
        maidenName
        placeOfBirth
        gender
        dateOfBirth
        typeOfIdentification
        NIS
        trn
        occupation
        previouslyMarried
        divorceOrWidowed
        employed
        salary
        primaryContactNo
        financiallyCapable
        nameOfEmployer
        addressOfEmployer {
          addressLine1
          city
          country
          addressLine2
          parish
        }
        otherIncomeSource
        notfinanciallyCapableReason
        jamaicanEmployedState
        jamaincaSpouseLiving
      }
      employerInfo {
        orgId
        name
        tradingName
        description
        email
        registrationNo
        trn
        incorporationDate
        type
        dateOfRegistration
        fax
        operatingAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
          parish
        }
        natureOfBusiness
        website
        primaryContactNo
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
          parish
        }
        logo
        country
        status
        isSubsidiary
        workPermitIsInRelationTo
        saffCompsition {
          citizenship
          professional
          clerksOrServiceWorker
          skilledWorkers
          plantAndMachineOperators
          elementaryOccupations
          total
        }
        credentialNo
        wpExpiry
        tccExpiryDate
        tccNumber
      }
      legacy
      jobInfo {
        JobTitle
        description
        necessaryQualification
        salaryOffered
        allowances {
          house
          car
          entertainment
          other
        }
        currency
        stepsForJaimacan {
          internalRecruitment

          didJamaicanApply
          appliedCandidates
          noStepTaken
          reasonNoneHired
          byAdvertisement
        }
        JobId
        benefitsReceived
        jobDuties
        registeredLMIS
        workingHours
      }
      status
      type
      dependentInfo {
        dependentType
        name
        relationship
        passportNumber
        age
        gender
        nationality
        documents {
          name
          type
          src
          fileType
          expiry
        }
      }
      certificateInfo {
        dateOfApplication
        issuanceDate
        issuingAutority
        credentialNo
      }
      studentEducationDetail {
        educationType
        degreeOrCertificate
        instituteName
        instituteAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
        primaryContactNo
        email
      }
    }
  }
`;
